<template>
  <div>
    <section class="service-title-wrap">
      <h4 class="service-title">{{ $t('menuService.deliveryTakeout') }}</h4>
      <div class="service-title-sub">{{ $t('deliveryTakeaway.headCopy') }}</div>
    </section>

    <section>
      <div class="service-item" :data-id="$t('deliveryTakeaway.baeminOne.name')">
        <h5 :id="$t('deliveryTakeaway.baeminOne.name')">{{ $t('deliveryTakeaway.baeminOne.name') }}</h5>
        <div class="service-item-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/one@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/service/m/one@3x.jpg 3x">
            <img src="~@/static/image/service/pc/one.jpg" :alt="$t('deliveryTakeaway.baeminOne.name')">
          </picture>
        </div>
        <div class="service-item-title">
          <img
            src="~@/static/image/logo-family/logo_one.png"
            srcset="~@/static/image/logo-family/logo_one@2x.png 2x, ~@/static/image/logo-family/logo_one@3x.png 3x"
            :alt="$t('deliveryTakeaway.baeminOne.name')"
          >
          <html-view tag="p" :value="$t('deliveryTakeaway.baeminOne.title')" />
        </div>
        <div class="service-item-content">
          <html-view :value="$t('deliveryTakeaway.baeminOne.content')" />
        </div>
      </div>
      <div class="service-item" :data-id="$t('deliveryTakeaway.takeOut.name')">
        <h5 :id="$t('deliveryTakeaway.takeOut.name')">{{ $t('deliveryTakeaway.takeOut.name') }}</h5>
        <div class="service-item-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/takeout@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/service/m/takeout@3x.jpg 3x">
            <img src="~@/static/image/service/pc/takeout.jpg" :alt="$t('deliveryTakeaway.takeOut.name')">
          </picture>
        </div>
        <div class="service-item-title">
          <img
            src="~@/static/image/logo-family/logo_takeout.png"
            srcset="~@/static/image/logo-family/logo_takeout@2x.png 2x, ~@/static/image/logo-family/logo_takeout@3x.png 3x"
            :alt="$t('deliveryTakeaway.takeOut.name')"
          >
          <html-view tag="p" :value="$t('deliveryTakeaway.takeOut.title')" />
        </div>
        <div class="service-item-content">
          <html-view :value="$t('deliveryTakeaway.takeOut.content')" />
        </div>
      </div>
      <div class="service-item" :data-id="$t('deliveryTakeaway.robots.name')">
        <h5 :id="$t('deliveryTakeaway.robots.name')">{{ $t('deliveryTakeaway.robots.name') }}</h5>
        <div class="service-item-image">
          <picture>
            <source media="(min-width: 750px)" srcset="~@/static/image/service/pc/robot@3x.jpg 3x">
            <source media="(max-width: 750px)" srcset="~@/static/image/service/m/robot@3x.jpg 3x">
            <img src="~@/static/image/service/pc/robot.jpg" :alt="$t('deliveryTakeaway.robots.name')">
          </picture>
        </div>
        <div class="service-item-title">
          <img
            src="~@/static/image/logo-family/logo_robot.png"
            srcset="~@/static/image/logo-family/logo_robot@2x.png 2x, ~@/static/image/logo-family/logo_robot@3x.png 3x"
            :alt="$t('deliveryTakeaway.robots.name')"
          >
          <html-view tag="p" :value="$t('deliveryTakeaway.robots.title')" />
        </div>
        <div class="service-item-content">
          <html-view :value="$t('deliveryTakeaway.robots.content')" />
          <div class="btn-go-site"><a href="https://robot.baemin.com/" class="btn-blank" target="_blank">{{ $t('deliveryTakeaway.robots.site') }}<icon-blank /></a></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {
    iconBlank: () => import('@/static/svg/blank.svg'),
  },
}
</script>
